import { onDocumentScroll } from "../../js/utils";

function pauseWhenOutOfView(
  video: HTMLVideoElement,
  videoIsPaused: boolean,
  onToggle: (videoIsPaused: boolean) => void
) {
  const topPos = video.getBoundingClientRect().top;

  const isOutsideView =
    0 > topPos + video.offsetHeight || window.innerHeight < topPos;

  if (isOutsideView && !videoIsPaused) {
    video.pause();
    onToggle(true);
  }

  if (!isOutsideView && videoIsPaused) {
    video.play();
    onToggle(false);
  }
}

export function heroVideos() {
  // This is to stop video when out of viewport.
  const wrappers = document.querySelectorAll(".hero-component__video-wrapper");
  wrappers.forEach((wrapper) => {
    const video: HTMLVideoElement | null = wrapper.querySelector("video");
    let videoIsPaused = false;

    setTimeout(() => {
      onDocumentScroll(() => {
        video &&
          pauseWhenOutOfView(video, videoIsPaused, (b) => {
            videoIsPaused = b;
          });
      });
    }, 150);
  });
}
